
(function () {
  // === Kurallar (Insider Sale: %25 sitewide) ===
  const DN_TOKEN = 'SDF7S5FB8TA3X';
  const SITEWIDE_RATE = 0.25;
  const noDiscountLinks = [                // %0
    '/products/international-shipping-canada', '/products/international-shipping-worldwide', '/products/fedex-2day-shipping',
    '/products/shipping', '/products/delivery-with-signature', '/products/gift-wrap'
  ];

  // DN artık token'ı _la_dn cookie'sine değil sessionStorage 'la-dn-savedtoken'a yazıyor
  function tokenOk() {
    try {
      if (new URLSearchParams(location.search).get('token') === DN_TOKEN) return true;
      if ((sessionStorage.getItem('la-dn-savedtoken') || '').includes(DN_TOKEN)) return true;
    } catch(_) {}
    for (const c of document.cookie.split('; ')) {
      if (!c.startsWith('_la_dn')) continue;
      try {
        const parsed = JSON.parse(decodeURIComponent(c.slice(c.indexOf('=') + 1)));
        if (parsed?.Tokens?.includes(DN_TOKEN)) return true;
      } catch(_) {}
    }
    return false;
  }

  function getRate(href) {
    if (noDiscountLinks.some(x => href.includes(x))) return 0;
    return SITEWIDE_RATE;
  }

  function parseCents(text){
    if (!text) return null;
    const cleaned = String(text).replace(/[^\d.,]/g,'').replace(/\s+/g,'');
    const normalized = cleaned.replace(/(\d)[.,](?=\d{3}\b)/g,'$1').replace(',', '.');
    const v = parseFloat(normalized);
    return isNaN(v) ? null : Math.round(v*100);
  }
  function fmt(c){
    if (window.Shopify?.formatMoney) {
      const f = (window.theme && theme.moneyFormat) || "${{amount}}";
      return Shopify.formatMoney(c, f);
    }
    return "$" + (c/100).toFixed(2);
  }

  // ——— Watcher (brute-force, timing-proof) ———
  let lastHiddenText = null;
  let lastAppliedCents = null;

  function applyIfPossible() {
    const priceBox = document.querySelector('.product-price-and-sku .product__price.limoniapps-discountninja-productprice[data-price-wrapper]');
    const hiddenOriginal = document.querySelector('.limoniapps-discountninja-productprice-original [data-product-price]');
    if (!priceBox || !hiddenOriginal) return;

    const hiddenText = hiddenOriginal.textContent || '';
    const originalCents = parseCents(hiddenText);
    const replaced = priceBox.querySelector('.limoniapps-discountninja-productprice-replaced');

    // Oran
    const rate = tokenOk() ? getRate(location.pathname) : 0;
    if (originalCents == null || !replaced) return;

    // Her değişimde birkaç kere üst üste deneyeceğiz (DN bazen 100–300ms gecikmeli renderlıyor)
    if (hiddenText !== lastHiddenText || originalCents !== lastAppliedCents) {
      // indirimli ve orijinal yaz
      const discountedCents = Math.max(0, Math.round(originalCents * (1 - rate)));

      const discText =
        replaced.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money .money') ||
        replaced.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money');
      if (discText) discText.textContent = fmt(rate ? discountedCents : originalCents);

      const origText =
        replaced.querySelector('.limoniapps-discountninja-shortcode-original_price .money .money') ||
        replaced.querySelector('.limoniapps-discountninja-shortcode-original_price .money');
      if (origText) origText.textContent = fmt(originalCents);

      // data-* cent senkronu
      replaced.querySelectorAll('.limoniapps-discountninja-shortcode-discounted_price .limoniapps-discountninja-money')
        .forEach(n => {
          const cents = rate ? discountedCents : originalCents;
          n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(cents));
          n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(cents));
          n.setAttribute('data-geolizr-price', String(cents));
          n.setAttribute('doubly-currency-usd', String(cents));
        });
      replaced.querySelectorAll('.limoniapps-discountninja-shortcode-original_price .limoniapps-discountninja-money')
        .forEach(n => {
          n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(originalCents));
          n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(originalCents));
          n.setAttribute('data-geolizr-price', String(originalCents));
          n.setAttribute('doubly-currency-usd', String(originalCents));
        });

      // küçük dürtme (DN/observer’lar)
      priceBox.setAttribute('data-dn-tick', Date.now());

      // yine de gecikme olabilir; 3 ek atış planla
      [80, 220, 600].forEach(delay => setTimeout(() => {
        const rep2 = document.querySelector('.product-price-and-sku .product__price.limoniapps-discountninja-productprice [class*="productprice-replaced"]');
        if (!rep2) return;
        const discText2 =
          rep2.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money .money') ||
          rep2.querySelector('.limoniapps-discountninja-shortcode-discounted_price .money');
        if (discText2) discText2.textContent = fmt(rate ? discountedCents : originalCents);

        const origText2 =
          rep2.querySelector('.limoniapps-discountninja-shortcode-original_price .money .money') ||
          rep2.querySelector('.limoniapps-discountninja-shortcode-original_price .money');
        if (origText2) origText2.textContent = fmt(originalCents);

        rep2.querySelectorAll('.limoniapps-discountninja-shortcode-discounted_price .limoniapps-discountninja-money')
          .forEach(n => {
            const cents = rate ? discountedCents : originalCents;
            n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(cents));
            n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(cents));
            n.setAttribute('data-geolizr-price', String(cents));
            n.setAttribute('doubly-currency-usd', String(cents));
          });
        rep2.querySelectorAll('.limoniapps-discountninja-shortcode-original_price .limoniapps-discountninja-money')
          .forEach(n => {
            n.setAttribute('data-limoniapps-discountninja-price-cents-basecurrency', String(originalCents));
            n.setAttribute('data-limoniapps-discountninja-price-cents-presentmentcurrency', String(originalCents));
            n.setAttribute('data-geolizr-price', String(originalCents));
            n.setAttribute('doubly-currency-usd', String(originalCents));
          });

        priceBox.setAttribute('data-dn-tick', Date.now());
      }, delay));

      lastHiddenText = hiddenText;
      lastAppliedCents = originalCents;
    }
  }

  // 1) Sürekli hafif “heartbeat”: 300ms’de bir kontrol (çok hafif CPU; yalnızca ürün sayfasında)
  const heartbeat = setInterval(applyIfPossible, 300);

  // 2) Sayfa görünürlüğü kapanınca durdur (sekme gizlenince yük binmesin)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clearInterval(heartbeat);
  });

  // 3) İlk tetik
  applyIfPossible();
})();
